module.exports = __webpack_public_path__ + "img/mobile-subtitle.143e2520.webp";